<div class="upsert-entity-data">
  <div class="button-group">
    <button mat-stroked-button type="submit" class="submit" form="formUpsertMember" [disabled]="isSubmitting">
      Save
    </button>

    <button mat-stroked-button type="button" class="cancel" (click)="onCancel()">Cancel</button>
  </div>
  <div class="pb-6" *ngIf="isRetired && bannerType">
    <ptg-banner [(bannerType)]="bannerType" [message]="message"></ptg-banner>
  </div>
  <form id="formUpsertMember" class="flex flex-col gap-2" [formGroup]="formGroup" (ngSubmit)="formSubmit$.next()">
    <div
      *ngFor="let f of controls"
      [hidden]="f.isHidden"
      [class.read-only-row]="f.disableRow || f?.configs?.fixedKey === FixedPropertyKey.RelationShip"
      class="flex gap-4"
      style="width: 1100px"
    >
      <ng-container [ngSwitch]="f.type" *ngIf="!f.isHidden">
        <div *ngSwitchCase="EntityPropertyType.Status" class="flex-1">
          <div *ngFor="let childForm of f.lstChildFormControl" class="mb-2">
            <ptg-select
              [controlField]="childForm.formControl"
              [placeholder]="childForm.label"
              [listData]="childForm.key === 'status' ? childForm.lstOption || [] : listStatusEvent || []"
              [isOptionObj]="true"
              [isRequired]="true"
              (changeOptionValue)="setStatus(childForm)"
            ></ptg-select>
          </div>
        </div>

        <div *ngSwitchCase="EntityPropertyType.Currency" class="flex-1">
          <ptg-textbox
            [controlField]="f.formControl"
            [hasLabel]="true"
            [placeholder]="f.label"
            [maxLength]="f.maxLength"
            [min]="f.min"
            [max]="f.max"
            [isRequired]="f.isRequired"
            inputType="Currency"
            [errorAsync]="f.label + ' already exists.'"
          ></ptg-textbox>
        </div>

        <div
          *ngSwitchCase="
            [EntityPropertyType.Email, EntityPropertyType.Phone, EntityPropertyType.SSN].includes(f.type) ? f.type : ''
          "
          class="flex-1"
        >
          <ptg-textbox
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [hasLabel]="true"
            [maxLength]="f.maxLength"
            [isRequired]="f.isRequired"
            [isShowIconMasked]="f?.configs?.masked == 'true'"
            [inputType]="EntityPropertyType[f.type]"
            [errorAsync]="f.label + ' already exists.'"
            [customError]="f?.configs?.unique === 'true' ? 'notUnique' : ''"
          ></ptg-textbox>
        </div>

        <div *ngSwitchCase="'EIN'" class="flex-1">
          <ptg-textbox
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [hasLabel]="true"
            [maxLength]="f.maxLength"
            [isRequired]="f.isRequired"
            [isShowIconMasked]="f?.configs?.masked == 'true'"
            [inputType]="'EIN'"
            [errorAsync]="f.label + ' already exists.'"
            [customError]="f?.configs?.unique === 'true' ? 'notUnique' : ''"
          ></ptg-textbox>
        </div>

        <div *ngSwitchCase="EntityPropertyType.Text" class="flex-1">
          <ptg-textbox
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [hasLabel]="true"
            [maxLength]="f.maxLength !== 'none' ? f.maxLength : '250'"
            [isRequired]="f.isRequired"
            [isShowIconMasked]="f?.configs?.masked == 'true'"
            [inputType]="EntityPropertyType[f.type]"
            [errorAsync]="f.label + ' already exists.'"
            [customError]="f?.configs?.unique === 'true' ? 'notUnique' : ''"
          ></ptg-textbox>
        </div>

        <div
          *ngSwitchCase="
            [EntityPropertyType['Whole Number'], EntityPropertyType.Decimal].includes(f.type) ? f.type : ''
          "
          class="flex-1"
        >
          <ptg-textbox
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [hasLabel]="true"
            [mask]="
              f.type === EntityPropertyType['Whole Number']
                ? 'separator.0'
                : f.fractionalLength
                  ? 'separator.' + f.fractionalLength
                  : 'separator'
            "
            [thousandSeparator]="','"
            [min]="f.min"
            [max]="f.max"
            inputType="Decimal"
            [isRequired]="f.isRequired"
            [errorAsync]="f.label + ' already exists.'"
            [customError]="f?.configs?.unique === 'true' ? 'notUnique' : ''"
          ></ptg-textbox>
        </div>

        <div *ngSwitchCase="EntityPropertyType.Date" class="flex-1">
          <ptg-datepicker
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [isRequired]="f.isRequired"
            [minDate]="f.min"
            [maxDate]="f.max"
            [errorMinDate]="f.minMessage"
            [errorMaxDate]="f.maxMessage"
            [errorAsync]="f.label + ' already exists.'"
            customError="errorMsg"
            (changeValue)="dateValueChange($event, f)"
          ></ptg-datepicker>
        </div>

        <div *ngSwitchCase="EntityPropertyType['Person Name']" class="flex flex-1 gap-4">
          <div class="flex-1" *ngFor="let childForm of f.lstChildFormControl">
            <ng-container *ngIf="childForm.type === 'select'">
              <ptg-select
                [controlField]="childForm.formControl"
                [placeholder]="childForm.label"
                [listData]="childForm.lstOption || []"
                [isOptionObj]="true"
                [hasNoneValue]="!f.isRequired || !childForm.required"
                [isRequired]="f.isRequired && childForm.required"
              ></ptg-select>
            </ng-container>
            <ng-container *ngIf="childForm.type === 'text'">
              <ptg-textbox
                [controlField]="childForm.formControl"
                [placeholder]="childForm.label"
                [hasLabel]="true"
                [maxLength]="childForm.maxLength"
                [isRequired]="f.isRequired && childForm.required"
              ></ptg-textbox>
            </ng-container>
          </div>
        </div>
        <div *ngSwitchCase="EntityPropertyType.Address" class="flex flex-1 gap-4 flex-wrap">
          <h3 class="address-label">
            {{ f.label }}
            <span class="address-active" *ngIf="isEffectiveData && data && f?.isActive">Active</span>
          </h3>
          <div class="flex-1" *ngFor="let childForm of f.lstChildFormControl; let i = index">
            <div [ngClass]="{ 'w-50': i < 2 }">
              <ng-container *ngIf="childForm.type === 'select'">
                <ptg-select
                  [controlField]="childForm.formControl"
                  [placeholder]="childForm.label"
                  [listData]="childForm.lstOption || []"
                  [isOptionObj]="true"
                  [hasNoneValue]="!f.isRequired || !childForm.required"
                  [isClearError]="(f.isRequired && childForm.required) || childForm?.isSetRequired"
                  [isRequired]="(f.isRequired && childForm.required) || childForm?.isSetRequired"
                  (changeOptionValue)="changeValueAddress(childForm, f?.lstChildFormControl, f)"
                ></ptg-select>
              </ng-container>
              <ng-container *ngIf="childForm.type === 'text'">
                <ng-container *ngIf="childForm.key === 'zipCode'">
                  <ptg-textbox
                    *ngIf="checkTextbox(f.lstChildFormControl)"
                    [controlField]="childForm.formControl"
                    [placeholder]="childForm.label"
                    [hasLabel]="true"
                    [maxLength]="childForm.maxLength"
                    [isRequired]="(f.isRequired && childForm.required) || childForm?.isSetRequired"
                    inputType="ZipCode"
                    (onOutFocus)="changeValueInputAddress(f)"
                  ></ptg-textbox>
                  <ptg-textbox
                    *ngIf="!checkTextbox(f.lstChildFormControl)"
                    [controlField]="childForm.formControl"
                    [placeholder]="childForm.label"
                    [hasLabel]="true"
                    [maxLength]="childForm.maxLength"
                    [isRequired]="(f.isRequired && childForm.required) || childForm?.isSetRequired"
                    (onOutFocus)="changeValueInputAddress(f)"
                  ></ptg-textbox>
                </ng-container>
                <ng-container *ngIf="childForm.key !== 'zipCode'">
                  <ptg-textbox
                    [controlField]="childForm.formControl"
                    [placeholder]="childForm.label"
                    [hasLabel]="true"
                    [maxLength]="childForm.maxLength"
                    [isRequired]="(f.isRequired && childForm.required) || childForm?.isSetRequired"
                    (onOutFocus)="changeValueInputAddress(f)"
                  ></ptg-textbox>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="childForm.type === 'date'">
                <ptg-datepicker
                  [controlField]="childForm.formControl"
                  [placeholder]="childForm.label"
                  [isRequired]="
                    childForm.key === 'effectFrom'
                      ? (f.isRequired && childForm.required) || childForm?.isSetRequired
                      : childForm.required
                  "
                  [minDate]="MY_DATE.minDate"
                  [maxDate]="MY_DATE.maxDate"
                  [isValidation]="true"
                  customError="errorMsg"
                  [errorAsync]="childForm?.messageError"
                  (changeValue)="dateEffectiveChange($event, f?.lstChildFormControl)"
                  (onOutFocus)="changeValueInputAddress(f)"
                ></ptg-datepicker>
              </ng-container>
            </div>
          </div>
        </div>

        <div
          *ngSwitchCase="
            [
              EntityPropertyType.Lookup,
              EntityPropertyType.Employer,
              EntityPropertyType.Department,
              EntityPropertyType.Tier
            ].includes(f.type)
              ? f.type
              : ''
          "
          class="flex-1"
        >
          <ptg-select
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [listData]="f.lstOption"
            [isOptionObj]="true"
            [isSetMaxWidthSelect]="true"
            [hasNoneValue]="!f.isRequired"
            [isRequired]="f.isRequired"
            [isMultipleLineOption]="f.type === EntityPropertyType.Department"
            (changeOptionValue)="changeLookup(f, $event)"
            customError="customError"
          ></ptg-select>
        </div>

        <div *ngSwitchCase="EntityPropertyType.Binary" class="flex-1">
          <ptg-checkbox
            [controlField]="f.formControl"
            [label]="f.label"
            [customError]="f?.customError"
            (changeValue)="f.staticPropertyType === StaticPropertyType.IsPrimary ? isPrimaryChange($event) : null"
          ></ptg-checkbox>
        </div>

        <div *ngSwitchCase="EntityPropertyType.Percentage" class="flex-1">
          <ptg-textbox
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [hasLabel]="true"
            [mask]="
              f.type === EntityPropertyType['Whole Number']
                ? 'separator.0'
                : f.fractionalLength
                  ? 'separator.' + f.fractionalLength
                  : 'separator'
            "
            [thousandSeparator]="','"
            [min]="f.min"
            [max]="f.max"
            [isPercentage]="true"
            inputType="Decimal"
            [isRequired]="f.isRequired"
            [errorAsync]="
              f.staticPropertyType === StaticPropertyType.Percentage
                ? 'Total Percentage of all Primary Beneficiaries must equal or less than 100%'
                : f.label + ' already exists.'
            "
          ></ptg-textbox>
        </div>

        <div *ngSwitchCase="EntityPropertyType.RichText" class="flex-1">
          <ptg-editor
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [isRequired]="f.isRequired"
            [maxLength]="f.maxLength"
            [hasFloatLabel]="true"
          ></ptg-editor>
        </div>

        <div *ngSwitchCase="EntityPropertyType['Date Time']" class="flex-1">
          <ptg-datetime-picker
            [controlField]="f.formControl"
            [isRequired]="f.isRequired"
            [isDisabled]="f.formControl.disabled"
            [datePlaceholder]="'Date'"
            [timePlaceholder]="'Time'"
          ></ptg-datetime-picker>
        </div>

        <div *ngSwitchDefault class="flex-1">
          <!-- TODO Replace EntityPropertyType[f.type] by f.type and Replace InputType by EntityPropertyType insde ptg-textbox  -->
          <ptg-textbox
            *ngIf="!(f.type === EntityPropertyType.Identifier && f.configs?.autogenerated === 'true')"
            [controlField]="f.formControl"
            [placeholder]="f.label"
            [hasLabel]="true"
            [maxLength]="f.maxLength"
            [isRequired]="f.isRequired"
            [inputType]="EntityPropertyType[f.type]"
            [errorAsync]="f.label + ' already exists.'"
            [customError]="f?.configs?.unique === 'true' ? 'notUnique' : ''"
          ></ptg-textbox>
          <div
            *ngIf="f.type === EntityPropertyType.Identifier && f.configs?.autogenerated === 'true'"
            class="identifier-auto-generated-label-display"
          >
            <span class="label truncate">{{ f.label + ': ' }}</span>
            <span class="value truncate">{{
              (f.configs?.patternPrefix || '') + (f.formControl.value || '') + (f.configs?.patternSuffix || '') || '-'
            }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <div *ngFor="let p of propertyReferences; let i = index" class="mb-4 border-top">
      <div class="property-reference">
        <span class="property-name truncate">{{ p.label }}</span>
        <ptg-edit-property-entity-reference
          [entityCtrl]="erFormRadioButton[p.entityPropertyId]"
          [controls]="erControls[p.entityPropertyId]"
          [formGroup]="erFormGroup[p.entityPropertyId]"
          [property]="p"
          [cardInfor]="cardInfor"
          [screenId]="screenId"
          [listUnique]="getListUnique()"
          [uniqueOtherReference]="getUniqueOtherReference(p)"
          [recordData]="data"
          [isEdit]="isEdit"
          [targetId]="targetId"
          [isMuniPortal]="isMuniPortal"
          (onRecordChange)="onRecordChange($event)"
          (entityRealSender)="getEntityReal($event)"
          (onAddNew)="onAddNewEntityReference($event)"
        >
        </ptg-edit-property-entity-reference>
      </div>
    </div>

    <!-- Fixed properties -->
    <div *ngIf="fixedProperties?.length" class="flex flex-wrap column-gap-1rem w-100">
      <div *ngFor="let p of fixedProperties" [ngClass]="p.class ?? ''">
        <ng-container [ngSwitch]="p.type">
          <div *ngSwitchCase="EntityPropertyType.Date" class="flex-1">
            <ptg-datepicker
              [controlField]="fixedFormGroup.get(p.key)"
              [placeholder]="p.label"
              [isRequired]="p.isRequired"
              [minDate]="p.minValue"
              [maxDate]="p.maxValue"
              customError="customErrorMessage"
              (changeValue)="onChangeDate($event)"
              (onInput)="inputFieldsBeginDate()"
            ></ptg-datepicker>
          </div>
          <div *ngSwitchCase="EntityPropertyType.Lookup" class="flex-1">
            <ptg-select
              [controlField]="fixedFormGroup.get(p.key)"
              [placeholder]="p.label"
              [listData]="p.options"
              [isOptionObj]="true"
              [isSetMaxWidthSelect]="true"
              [hasNoneValue]="!p.isRequired"
              [isRequired]="p.isRequired ?? false"
            ></ptg-select>
          </div>
        </ng-container>
      </div>
    </div>
  </form>
</div>
